import customAxios from "../../customAxios";
import { FIND_ME } from "../../routes";

const findArea = async () => {
  var thisUrl = FIND_ME;

  try {
    return (await customAxios.get(thisUrl)).data;
  } catch (error: any) {
    console.log({ FIND_ME: error });
  }
};

export default findArea;
